const getInfoThemeActif = (themes) => {
  const themeActif = themes.find((theme) => theme.active === 1);
  return themeActif ? `${themeActif.name} ${themeActif.version}` : "";
};

export default getInfoThemeActif;
